import { AfterViewInit, Component } from '@angular/core';

import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

import { AuthenticationService } from '../shared/authentication.service';
import { EventService } from '../shared/event.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements AfterViewInit {

  private loginCompletedSource = new Subject<boolean>();
  loginCompleted$: Observable<boolean> = this.loginCompletedSource.asObservable();
  logOutReason: string;

  constructor(private authenticationService: AuthenticationService,
              private eventService: EventService) { }

  ngAfterViewInit(): void {
    this.eventService.focusField('login-btn');
  }

  goToAuthorizationServer() {
      this.authenticationService.openChildWindowToAuthorizationServer().then(
          success => {
            if (success) {
              this.loginCompletedSource.next(true);
            }
          }
      );
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/login/login.component.ts